import React from "react";
import useLanguageStore from "../../stores/useLanguageStore";

const languages = [
  { code: "sv", label: "SV" },
  { code: "en", label: "EN" },
];

function LanguageToggle() {
  const currentLanguage = useLanguageStore((state) => state.language);
  const setLanguage = useLanguageStore((state) => state.setLanguage);

  return (
    <div className="language-toggle">
      {languages.map(({ code, label }) => (
        <button
          key={code}
          type="button"
          className={
            code === currentLanguage
              ? "language-toggle--option language-toggle--option-active"
              : "language-toggle--option"
          }
          onClick={() => setLanguage(code)}
        >
          {label}
        </button>
      ))}
    </div>
  );
}

export default LanguageToggle;
